import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormArray, Validators } from '@angular/forms';
import { format } from 'date-fns';
import { NamedId } from 'src/app/models/NamedId';
import { PreferencesService } from 'src/app/services/preferences.service';
import { Country, CountryList } from '../../../models/countries';
import { HelenaApiService } from '../../../services/helena-api.service';


@Component({
  selector: 'app-helena-request',
  templateUrl: './helena-request.component.html'
})
export class HelenaRequestComponent implements OnInit {
  @ViewChild('formedEmail', { read: ElementRef }) formedEmail: ElementRef;

 
  applicationUnitChoices: string[] = ['Litres', 'Millilitres', 'Kilogrammes', 'Grammes'];
  countryChoices: Country[] = CountryList;
  tankmixRequestForm:FormGroup;
  currentValues:any;
 
  constructor(private helenaApi: HelenaApiService, private fb: FormBuilder, private preferenceService:PreferencesService) { 

    this.tankmixRequestForm=this.fb.group({
      name:['',Validators.required],
      email:['',[Validators.required,Validators.email]],
      requestDate:[new Date(),Validators.required],
      country:[null,Validators.required],
      company:[null],
      comments:[null],
      waterRate:[null,Validators.required],
     
     
       ingredients:this.fb.array([])
    });
    this.tankmixRequestForm.valueChanges.subscribe(values=>{
this.currentValues=values;

    });
  }

  ngOnInit() {

    this.preferenceService.forceToAmerica()
    this.tankmixRequestForm.patchValue( {
      kind:'helena',
      name: null,
      email: null,
      company: null,
      country: null,
      requestDate: format(new Date(), 'dd/MM/yyyy'),
      waterRate: null,
      comments: null,
     
    });
    this.addProduct();
    this.addProduct();
  }
  get ingredients(): UntypedFormArray {
    return this.tankmixRequestForm.get("ingredients") as UntypedFormArray;
  }
  addProduct() {
  
   this.ingredients.push(this.fb.group(
      {
        name: [null,Validators.required],
        orderOfAddition:[ this.ingredients.length + 1],
        applicationRate: [null,Validators.required],
        applicationUnit: ['',Validators.required],
      })
    );
  }
formHasError(controlName:string): boolean{
 return this.tankmixRequestForm.controls[controlName].errors!=null;
}

ingredientHasError(index:number,controlName:string): boolean{
  return (this.ingredients.at(index) as FormGroup) .controls[controlName].errors!=null;
 }
  deleteProduct(index) {
     this.ingredients.removeAt(index);
  }
  submitRequest() {
    const html = document.getElementById('formedEmail').innerHTML;

    this.helenaApi.submitRequest(this.currentValues, html).subscribe();
  }
}
